import type { InterventionReason } from './interventionRequiredAction';
import { interventionReasonSchema } from './interventionRequiredAction';
import { Joi, objectSchemaOf } from '../helpers';

export interface IRequestInterventionParams {
  conversationId: string;
  reason: InterventionReason;
  description: string;
}

export const requestInterventionParamsSchema = objectSchemaOf<IRequestInterventionParams>(
  {
    conversationId: Joi.string().required(),
    reason: interventionReasonSchema.required(),
    description: Joi.string().required(),
  }
);
